module.exports = __webpack_public_path__ + "img/xydxxjs.c620ecd.png";